import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import JSZip from "jszip";

// JS Files
import MuiTextFieldHook from "../shares/MuiTextFieldHook";
import MuiButton from "../shares/MuiButton";
import MuiSelectHook from "../shares/MuiSelectHook";
import MuiTheme from "../shares/MuiTheme";
import MuiTextAreaHook from "../shares/MuiTextAreaHook";
import MuiUpload from "../shares/MuiUpload";
import useFetch from "../../context/useFetch";
import { Province } from "../../Province";
import UploadedFileBox from "./UploadedFileBox";
import SuccessModal from "./SuccessModal";
import RemoveFileModal from "./RemoveFileModal";
import { fixNumbers, typeRecordList } from "../../Utils";
import { useUserData } from "../../context/UserDataContext";
import { useAuth } from "../../context/AuthContext";
import OtpModal from "./OtpModal";

// Others Files

export const bimeList = [
  {
    name: "بیمه های تکمیل درمان ",
    value: "darman",
  },
  {
    name: "حوادث دانش آموزی",
    value: "daneshamooz",
  },
  {
    name: "بیمه های آتش سوزی ",
    value: "atashsoozi",
  },
  {
    name: "بیمه های خودرو",
    value: "khodro",
  },
  {
    name: "بیمه های مسئولیت ",
    value: "masouliat",
  },
  {
    name: "بیمه مدارس",
    value: "madares",
  },
];

const damageList = [
  {
    name: "هزینه بیمارستانی",
    value: "bimarestan",
  },

  {
    name: "دارو",
    value: "daroo",
  },
  {
    name: "پاراکلینیک ",
    value: "paraclinic",
  },
  {
    name: "دندان",
    value: "dandan",
  },
  {
    name: "سایر ",
    value: "sayer",
  },
];

const RecordForm = () => {
  const navigate = useNavigate();
  let windowWidth = window.screen.width;
  const {token} = useAuth();

  const { type } = useParams();
  const [fileData, setFileData] = useState();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const {
    watch,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name: "",
      mobile_number: "",
      province: "",
      city: "",
      damage_type: "",
      field: "",
      case_number: "",
      code: "",
      description: "",
    },
  });
  const [file, setFile] = useState([]);
  const [successModal, setSuccessModal] = useState(undefined);
  const [removeFileModal, setRemoveFileModal] = useState(undefined);
  const [postData, setPostData] = useState({});


  const handleRemoveFileModal = () => {
    setRemoveFileModal((before) => !before);
  };
  const AddCaseFileApi = useFetch({
    method: "post",
    url: "CaseAttachFiles_Service",
    trigger: false,
    data: fileData,
    // noHeader: true,
    argFunc: (res) => {
      if (res.data == "done") {
        setFile([]);
        reset();
        setSuccessModal(true);
        toast.success(
          `${
            type == "com-damage"
              ? "اعتراض"
              : type == "con-damage"
              ? "درخواست مشاوره خسارت"
              : "درخواست مشاوره پزشکی"
          } موردنظر با موفقیت ایجاد شد`,
          {
            position: toast.POSITION.TOP_CENTER,
          }
        );
      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const [code, setCode] = useState();
  const AddCaseApi = useFetch({
    method: "post",
    url: "Case_Service",
    trigger: false,
    data: postData,
    // noHeader: true,
    argFunc: (res) => {
      if (res.data == "done") {
        let formData = new FormData();
        setCode(res.unique_id);
        if (file.length > 0) {
          const zip = new JSZip();

          file.map((item) => {
            zip.file(item.name, item);

            // formData.append("attach_file", item, item.name);
          });
          let a;
          zip.generateAsync({ type: "blob" }).then(function (content) {
            // see FileSaver.js
            // saveAs(content, "example.zip");
            a = new File([content], `${res.id}.zip`);
            formData.append("attach_file", a, a.name);
            formData.append("case", res.id);
            setFileData(formData);
            if (file.length > 0) AddCaseFileApi.reFetch();
            else {
              reset();
              setSuccessModal(true);
              toast.success(
                `${
                  type == "com-damage"
                    ? "اعتراض"
                    : type == "con-damage"
                    ? "درخواست مشاوره خسارت"
                    : "درخواست مشاوره پزشکی"
                } موردنظر با موفقیت ایجاد شد`,
                {
                  position: toast.POSITION.TOP_CENTER,
                }
              );
            }
          });
        } else {
          reset();
          setSuccessModal(true);
          toast.success(
            `${
              type == "com-damage"
                ? "اعتراض"
                : type == "con-damage"
                ? "درخواست مشاوره خسارت"
                : "درخواست مشاوره پزشکی"
            } موردنظر با موفقیت ایجاد شد`,
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
        }
      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const onSubmit = (data) => {
    if (type !== "com-damage" && type !== "con-damage") {
      data["field"] = null;
    }
    if (data["field"] !== "darman" && data["field"] !== "khodro") {
      data["case_number"] = "";
      data["damage_type"] = null;
      data["reason"] = "";
    } else if (data["field"] == "khdro") {
      data["damage_type"] = null;
    }
    data["mobile_number"] = fixNumbers(data["mobile_number"]);
    data["code"] = fixNumbers(data["code"]);

    setPostData({
      ...data,
      "no_attach_file" :file.length <= 0? 'yes':'no',
      type:
        type == "com-damage"
          ? "complaint"
          : type == "con-damage"
          ? "damageConsultant"
          : "medConsultant",
    });

    AddCaseApi.reFetch();
  };
  const [selectedFile, setSelectedFile] = useState();

  const addFile = (f) => {
    setFile([...file, f]);
  };
  const removeFile = () => {
    let files = [...file];
    files.splice(selectedFile, 1);
    setFile(files);
    setRemoveFileModal(false);
  };
  const [loginModal , setLoginModal] = useState(token == null ? true : false);
  const handleLoginModal = () => {
    setLoginModal(before =>!before);
  }
  return (
    <>
      {successModal && (
        <SuccessModal
          openModal={successModal}
          setOpenModal={setSuccessModal}
          code={code}
        />
      )}
      {removeFileModal && (
        <RemoveFileModal
          openModal={removeFileModal}
          setOpenModal={setRemoveFileModal}
          removeFile={removeFile}
        />
      )}
      {loginModal && (
        <OtpModal
          openModal={loginModal}
          setOpenModal={setLoginModal}
          caseType={
            type == "com-damage"
              ? " ثبت اعتراض به پرونده خسارت"
              : type == "con-damage"
              ? "درخواست مشاوره خسارت"
              : "درخواست مشاوره پزشکی"
          }
        />
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="border rounded-lg mt-8 border-mygray-300 py-8 px-4">
          <div className="border-r-4 border-mygray-300 px-4">
            <span className="text-sm md:text-base font-bold text-mygray-700">
              کاربر گرامی به منظور{" "}
              {type == "com-damage"
                ? "اعتراض"
                : type == "con-damage"
                ? "درخواست مشاوره خسارت"
                : "درخواست مشاوره پزشکی"}{" "}
              خود لازم است نسبت به تکمیل موارد زیر اقدام نمایید.
            </span>
          </div>
          <div className="grid md:grid-cols-3 gap-8 md:gap-16 mt-8 md:mt-16 mx-4 md:mx-12">
            <MuiTheme>
              <MuiTextFieldHook
                id="outlined-basic"
                variant="outlined"
                size="small"
                label="نام و نام‌خانوادگی"
                name="name"
                control={control}
                register={{
                  required: {
                    value: true,
                    message: "نام و نام خانوادگی را وارد کنید",
                  },
                }}
              />
              <MuiTextFieldHook
                id="outlined-basic"
                variant="outlined"
                size="small"
                label="شماره همراه"
                name="mobile_number"
                control={control}
                isLTR
                register={{
                  required: {
                    value: true,
                    message: "شماره تلفن همراه را وارد کنید",
                  },
                }}
              />
              <MuiTextFieldHook
                id="outlined-basic"
                variant="outlined"
                size="small"
                label="کد ملی"
                name="code"
                control={control}
                isLTR
                register={{
                  required: {
                    value: true,
                    message: "کدملی را وارد کنید",
                  },
                }}
              />
              <MuiSelectHook
                size="small"
                inputLabel="استان"
                label="provience"
                control={control}
                name="province"
                register={{
                  required: {
                    value: true,
                    message: "استان را انتخاب کنید",
                  },
                }}
                labelId="provience-label"
                id="provience-select"
                menuItems={Province.map((it) => {
                  return { name: it.name, value: it.value };
                })}
                fromApi={false}
              />
              <MuiSelectHook
                size="small"
                inputLabel="شهر"
                label="city"
                control={control}
                name="city"
                register={{
                  required: {
                    value: true,
                    message: "شهر را انتخاب کنید",
                  },
                }}
                labelId="city-label"
                id="city-select"
                menuItems={
                  watch("province") !== undefined && watch("province") !== ""
                    ? Province.filter(
                        (it) => it.value == watch("province")
                      )[0].cities.map((ci) => {
                        return {
                          name: ci,
                          value: ci,
                        };
                      })
                    : []
                }
                fromApi={false}
              />
              {type !== "con-med" && (
                <MuiSelectHook
                  size="small"
                  inputLabel="رشته بیمه"
                  label="field"
                  control={control}
                  name="field"
                  register={{
                    required: {
                      value: true,
                      message: "رشته بیمه را انتخاب کنید",
                    },
                  }}
                  labelId="field-label"
                  id="field-select"
                  menuItems={bimeList}
                  fromApi={false}
                />
              )}
              {type == "com-damage" &&
              (watch("field") == "darman" || watch("field") == "khodro") ? (
                <MuiSelectHook
                  size="small"
                  inputLabel="علت اعتراض"
                  label="reason"
                  control={control}
                  name="reason"
                  register={{
                    required: {
                      value: true,
                      message: "علت را انتخاب کنید",
                    },
                  }}
                  labelId="reason-label"
                  id="reason-select"
                  menuItems={
                    watch("field") !== undefined && watch("field") !== ""
                      ? typeRecordList
                          .filter((it) => it.value == watch("field"))[0]
                          .records.map((ci) => {
                            return {
                              name: ci.name,
                              value: ci.name,
                            };
                          })
                      : []
                  }
                  fromApi={false}
                />
              ) : undefined}
              {type == "com-damage" &&
              (watch("field") == "darman" || watch("field") == "khodro") ? (
                <MuiTextFieldHook
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  label="شماره پرونده (اختیاری)"
                  name="case_number"
                  control={control}
                  isLTR
                />
              ) : undefined}
              {type == "com-damage" && watch("field") == "darman" ? (
                <MuiSelectHook
                  size="small"
                  inputLabel="نوع خسارت (اختیاری)"
                  label="damage-type"
                  control={control}
                  name="damage_type"
                  labelId="damage-type-label"
                  id="damage-type-select"
                  menuItems={damageList}
                  fromApi={false}
                />
              ) : undefined}
            </MuiTheme>
            {windowWidth > 768 ? (
              <div className="col-span-3">
                <MuiTextAreaHook
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  label="توضیحات"
                  name="description"
                  control={control}
                  placeholder={
                    type !== "com-damage" && type !== "con-damage"
                      ? "درج  زمینه درخواست مشاوره (شرح حال)"
                      : ""
                  }
                  register={{
                    required: {
                      value: true,
                      message: "توضیحات را وارد کنید",
                    },
                  }}
                />
              </div>
            ) : (
              <MuiTextAreaHook
                id="outlined-basic"
                variant="outlined"
                size="small"
                label="توضیحات"
                name="description"
                placeholder="درج  زمینه درخواست مشاوره (شرح حال)"
                control={control}
                register={{
                  required: {
                    value: true,
                    message: "توضیحات را وارد کنید",
                  },
                }}
              />
            )}
          </div>
        </div>
        <div className="border rounded-lg mt-8 border-mygray-300 py-8 px-4">
          {/* Desktop */}
          <div className="hidden md:border-r-4 md:border-mygray-300 md:px-4 md:flex  md:items-center">
            <span className="font-bold text-mygray-700">
              کاربر گرامی به منظور{" "}
              {type == "com-damage"
                ? "اعتراض"
                : type == "con-damage"
                ? "درخواست مشاوره خسارت"
                : "درخواست مشاوره پزشکی"}{" "}
              خود لازم است مدارک مربوط به پرونده را بارگذاری نمایید.
            </span>
            <div className="mr-8">
              <MuiUpload setImageFile={addFile} />
            </div>
          </div>
          {/* End Desktop */}
          {/* Mobile */}
          <div className="md:hidden flex flex-col items-center justify-center">
            <div className="border-r-4 border-mygray-300 px-4">
              <span className="text-sm md:text-base font-bold text-mygray-700">
                کاربر گرامی به منظور{" "}
                {type == "com-damage"
                  ? "اعتراض"
                  : type == "con-damage"
                  ? "درخواست مشاوره خسارت"
                  : "درخواست مشاوره پزشکی"}{" "}
                خود لازم است مدارک مربوط به پرونده را بارگذاری نمایید.
              </span>
            </div>
            <div className="mt-4">
              <MuiUpload setImageFile={addFile} />
            </div>
          </div>
          {/* End Mobile */}
          <div className="grid md:grid-cols-2 gap-8 mt-8 mx-4 md:mx-16">
            {file.map((item, index) => {
              return [
                <UploadedFileBox
                  item={item}
                  index={index}
                  handleRemoveFileModal={handleRemoveFileModal}
                  setSelectedFile={setSelectedFile}
                />,
              ];
            })}
          </div>
        </div>
        <div className="text-left mt-8 flex justify-between items-center">
          <MuiButton
            onClick={() => navigate("/")}
            type="submit"
            variant="outlined"
            color="primary"
            text="بازگشت"
          />
          <MuiButton
            // onClick={() => handleRemoveFileModal()}
            type="submit"
            variant="contained"
            color="primary"
            text="ثبت"
            disabled={AddCaseApi.loading}
          />
        </div>
      </form>
    </>
  );
};
export default RecordForm;
